import type { z } from "zod";

import type { ProductCategoryType } from "../../types";
import { useBaseProductFormSchema } from "./use-base-product-form-schema";

export const useAddProductFormSchema = (
  productCategory: ProductCategoryType
) => {
  const baseSchema = useBaseProductFormSchema(productCategory);

  return baseSchema;
};

export type AddProductFormSchema = z.infer<
  ReturnType<typeof useAddProductFormSchema>
> & {
  specification: string;
};
